module.exports = __webpack_public_path__ + "static/apple-icon-180x180-c4a200bd0e8f51b3f1de96f7bea4ad54.png";